export const validatePhone = (telefone: string) => {
    telefone = telefone?.replace(/\D/g, '');

    if (!(telefone?.length >= 10 && telefone?.length <= 11)) return false;

    if (telefone?.length == 11 && parseInt(telefone?.substring(2, 3)) != 9) return false;

    for (let n = 0; n < 10; n++) {
        if (telefone == new Array(11).join(n.toString()) || telefone == new Array(12).join(n.toString())) return false;
    }
    const codigosDDD = [11, 12, 13, 14, 15, 16, 17, 18, 19,
        21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46,
        47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73,
        74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95,
        96, 97, 98, 99];
    if (codigosDDD.indexOf(parseInt(telefone?.substring(0, 2))) == -1) return false;

    if (telefone?.length == 10 && [2, 3, 4, 5, 7].indexOf(parseInt(telefone.substring(2, 3))) == -1) return false;

    return true;
};

export const validateEmail = (email: string) => {
    return /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/.test(email)
}

export function validateCPF(input: string) {
    const strCPF = input?.replace('.', '')?.replace('.', '')?.replace('-', '');
    let Soma;
    let Resto;
    Soma = 0;

    if (
        input === '000.000.000-000' ||
        input === '111.111.111-11' ||
        input === '222.222.222-22' ||
        input === '333.333.333-33' ||
        input === '444.444.444-44' ||
        input === '555.555.555-55' ||
        input === '666.666.666-66' ||
        input === '777.777.777-77' ||
        input === '888.888.888-88' ||
        input === '999.999.999-99'
    )
        return false;
    if (strCPF?.length !== 11) {
        return false;
    }

    for (let i = 1; i <= 9; i++) {
        Soma += parseInt(strCPF?.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
    }

    if (Resto === 10 || Resto === 11) {
        Resto = 0;
    }

    if (Resto != parseInt(strCPF?.substring(9, 10))) {
        return false;
    }
    Soma = 0;

    for (let i = 1; i <= 10; i++) {
        Soma += parseInt(strCPF?.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
    }

    if (Resto === 10 || Resto === 11) {
        Resto = 0;
    }

    if (Resto != parseInt(strCPF?.substring(10, 11))) {
        return false;
    }
    return true;
}

export function clearString(value: string) {
    return value
      .toString()
      .replace(/\./g, '')
      .replace(/\-/g, '')
      .replace(/\//g, '')
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/\ /g, '')
      .replace(/\ /g, '');
}

export function getIsValidString(value?: string | unknown) {
    if (typeof value === "string" && value !== "") return true;
    return false;
}

export const getFormattedCart = ({
    debts,
    cart,
}: {
    debts: { 
        totalDebts: number; 
        groupedDebts: { 
            owner: string; 
            total: number; 
            debts: { id: string; price: string; original: { nmPraca: string } }[] 
        }[] 
    };
    cart: { 
        name: string;
    }[];
}) => {
    const filteredGroups = debts.groupedDebts?.filter(group =>
        cart?.some(cartItem => cartItem.name === group.owner)
    );

    const filteredItems = filteredGroups?.flatMap(group => group.debts);

    const total = filteredItems?.reduce(
        (sum: number, item) => sum + Number(item?.price.replace(/,/g, '.')),
        0
    );

    const selected = filteredItems?.map(item => item.id);

    return {
        selected,
        total: Number(total?.toFixed(2)),
        filteredItems,
    };
};

export const getFirstAndLastName = (fullName: string) => {
    const nameParts = fullName?.trim()?.split(' ');
    const firstName = nameParts?.[0] ?? "";
    const lastName = nameParts?.[1] ?? "";
    return { firstName, lastName };
}

export const openApp = (platform: "ios" | "android") => {
    const uri = platform === "ios" ? 
            "https://apps.apple.com/us/app/id6737811254" :
            "https://play.google.com/store/apps/details?id=br.com.freeflow";
    const win = window.open(uri, '_blank');
    win?.focus();
}

export const getIsAppleDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /mac|iphone|ipad|ipod/.test(userAgent);
  }